var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoin4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9252 25.5524C7.30084 26.0234 2.97621 20.8424 2.29112 14.0343C1.60603 7.18342 4.81739 1.27452 9.48457 0.803522C14.1517 0.37534 18.4764 5.51351 19.1186 12.3644C19.8037 19.1725 16.5924 25.0814 11.9252 25.5524Z",
    fill: "url(#paint0_linear_1_316)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64489 1.01737L9.48607 0.803284C4.81889 1.27428 1.60753 7.18318 2.29262 14.0341C2.97771 20.8422 7.30234 26.0232 11.9267 25.5522L10.0855 25.7234C5.41835 26.1944 1.13654 21.0563 0.451447 14.2054C-0.233643 7.39727 2.97771 1.48837 7.64489 1.01737V1.01737Z",
    fill: "url(#paint1_linear_1_316)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1408 24.268C7.94462 24.6962 4.04817 20.0719 3.44871 13.906C2.84926 7.78306 5.71808 2.4308 9.91425 2.04543C14.1104 1.61725 18.0069 6.24161 18.6063 12.4074C19.2058 18.5304 16.337 23.8827 12.1408 24.268Z",
    fill: "url(#paint2_linear_1_316)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3065 12.4502C17.7071 6.37006 13.8963 1.74571 9.78574 2.04543C9.81428 2.04543 9.8571 2.04543 9.91419 2.04543C14.1104 1.61725 18.0068 6.24161 18.6063 12.4074C19.2057 18.5304 16.3369 23.8827 12.1407 24.268C12.0836 24.2966 12.0266 24.3109 11.9695 24.3109C16.08 23.7542 18.906 18.4876 18.3065 12.4502V12.4502Z",
    fill: "#A86314"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_316",
    x1: 3.91821,
    y1: 27.5648,
    x2: 21.1739,
    y2: 25.8521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3912F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_316",
    x1: -1.94637,
    y1: 0.760466,
    x2: 0.280176,
    y2: 23.0687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFEE7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FFFFE1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FFFFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FFCF5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9A5A12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FFBF4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A86314"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_316",
    x1: 5.76089,
    y1: 26.1948,
    x2: 17.0221,
    y2: 25.0816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9A83D"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin4);
export default __webpack_public_path__ + "static/media/coin4.deba32c1a70753393a241bf99f5fa50a.svg";
export { ForwardRef as ReactComponent };